module.exports = __webpack_public_path__ + "img/noimg.3d04f52a.png";